import React from 'react';
import { FlagIconProps, GenericFlagIcon } from './GenericFlagIcon';
/** ![](data:image/svg+xml;base64,PHN2ZyAgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJub25lIiB2aWV3Ym94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+CiAgICAgIDxwYXR0ZXJuIGlkPSJncmlkIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICAgIDxyZWN0IGZpbGw9IiNkNGQ1ZGEiIHg9IjAiIHk9IjAiIHdpZHRoPSI4IiBoZWlnaHQ9IjgiLz4KICAgICAgICA8cmVjdCBmaWxsPSIjZjdmN2Y3IiB4PSI4IiB5PSIwIiB3aWR0aD0iOCIgaGVpZ2h0PSI4Ii8+CiAgICAgICAgPHJlY3QgZmlsbD0iI2Q0ZDVkYSIgeD0iOCIgeT0iOCIgd2lkdGg9IjgiIGhlaWdodD0iOCIgLz4KICAgICAgICA8cmVjdCBmaWxsPSIjZjdmN2Y3IiB4PSIwIiB5PSI4IiB3aWR0aD0iOCIgaGVpZ2h0PSI4Ii8+CiAgICAgIDwvcGF0dGVybj4KICAgIDwvZGVmcz4KICAgIDxyZWN0IGZpbGw9InVybCgjZ3JpZCkiIHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiLz4KICAgIDxwYXRoIGZpbGw9IiNEQzE0M0MiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE2IDI4YzYuNjI3IDAgMTItNS4zNzMgMTItMTJINGMwIDYuNjI3IDUuMzczIDEyIDEyIDEyeiIgY2xpcC1ydWxlPSJldmVub2RkIj48L3BhdGg+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMjggMTZjMC02LjYyNy01LjM3My0xMi0xMi0xMlM0IDkuMzczIDQgMTZoMjR6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiPjwvcGF0aD48cGF0aCBzdHJva2U9IiNFMUU1RTciIHN0cm9rZS13aWR0aD0iMiIgZD0iTTE2IDI5QzguODIgMjkgMyAyMy4xOCAzIDE2UzguODIgMyAxNiAzczEzIDUuODIgMTMgMTMtNS44MiAxMy0xMyAxM3oiPjwvcGF0aD48L3N2Zz4=) */
export function FlagPol(props: FlagIconProps) {
  return (
    <GenericFlagIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 28C22.6274 28 28 22.6274 28 16H4C4 22.6274 9.37258 28 16 28Z"
        fill="#DC143C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16H28Z"
        fill="white"
      />
    </GenericFlagIcon>
  );
}
